import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Paper,
  useTheme
} from '@mui/material';
import FeaturedEventCard from './FeaturedEventCard';
import FeaturedMajorCard from './FeaturedMajorCard';
import axios from 'axios';
import API_BASE_URL from "../../apiConfig";
import MKTypography from "../MKTypography";

const FeaturedSection = () => {
  const theme = useTheme();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedItems = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/events/featured`);
        setItems(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching featured events and majors:', err);
        setError('Failed to load featured events and majors. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedItems();
  }, []);

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  if (items.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Paper 
          sx={{ 
            p: 4, 
            textAlign: 'center',
            background: theme.palette.mode === 'dark' ? 'rgba(30,30,30,0.9)' : 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(10px)',
            border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
          }}
        >
          <MKTypography variant="h6" color="text.secondary" gutterBottom>
            No Featured Events or Majors Currently Available
          </MKTypography>
          <MKTypography variant="body2" color="text.secondary">
            Check back soon for upcoming gaming events and tournaments!
          </MKTypography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <MKTypography 
          variant="h3" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontWeight: 700,
            color: '#e91e63',
            textShadow: theme.palette.mode === 'dark' ? '2px 2px 4px rgba(0,0,0,0.3)' : '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Featured Events
        </MKTypography>
        <MKTypography 
          variant="h6" 
          color="text.secondary"
          sx={{ maxWidth: 600, mx: 'auto' }}
        >
          Discover exciting gaming events, tournaments, and community meetups in San Diego
        </MKTypography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            {item.item_type === 'major' ? (
              <FeaturedMajorCard major={item} />
            ) : (
              <FeaturedEventCard event={item} />
            )}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default FeaturedSection; 